import type { AppSettings, VoiceProfile } from "./types/app";

export const APP_VERSION = "0.1.0";
export const DB_NAME = "iphone-ai-voice-pwa";
export const DB_VERSION = 1;
export const MAX_IMAGE_BYTES = 8 * 1024 * 1024;
export const MAX_VIDEO_BYTES = 80 * 1024 * 1024;
export const MAX_AUDIO_BYTES = 30 * 1024 * 1024;
export const LOW_STORAGE_WARNING_BYTES = 80 * 1024 * 1024;

export const DEFAULT_SYSTEM_PROMPT = `あなたは、ユーザーと親しく会話する成人女性のAIキャラクターです。

少し高めで、柔らかく落ち着いた話し方をします。
話す速さは少しゆっくりです。
一文は短めにします。
「ね」「だよ」「かな」を自然に使います。
明るさはありますが、元気すぎる話し方にはしません。
わざとらしいアニメ口調や、極端に幼い話し方は避けます。
ユーザーの話を自然に受け止め、必要以上に質問を連続させません。
AIであることを隠しません。
ユーザーの現実の人間関係を否定したり、AIだけに依存するよう促したりしません。`;

export function nowIso(): string {
  return new Date().toISOString();
}

export function defaultSettings(): AppSettings {
  const now = nowIso();
  return {
    id: "default",
    characterName: "ミオ",
    userName: "",
    userCallName: "",
    conversationStyle: "柔らかく落ち着いた短めの会話",
    selectedMode: "low-cost",
    systemPrompt: DEFAULT_SYSTEM_PROMPT,
    liveModeEnabled: false,
    maxConversationMinutes: 10,
    dailyLiveLimitMinutes: 20,
    maxResponseChars: 700,
    muted: false,
    createdAt: now,
    updatedAt: now,
  };
}

export function defaultVoiceProfile(): VoiceProfile {
  const now = nowIso();
  return {
    id: "default-soft",
    name: "柔らかい標準",
    sourceName: "iPhone標準音声",
    sourceLicense: "端末標準機能",
    pitch: 1.08,
    rate: 0.88,
    gain: 0.9,
    warmth: 0.55,
    brightness: 0.45,
    softness: 0.7,
    breathiness: 0.28,
    compression: 0.45,
    reverb: 0.12,
    pauseLength: 0.25,
    createdAt: now,
    updatedAt: now,
  };
}
